import { useState } from "react";
import api, { apiError } from "@/lib/api";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ChangePasswordDialog({ open, setOpen }) {
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (nw !== confirm) { toast.error("A confirmação não coincide."); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Palavra-passe alterada.");
      setOpen(false);
      setCur(""); setNw(""); setConfirm("");
    } catch (err) { toast.error(apiError(err)); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DialogHeader><DialogTitle>Alterar palavra-passe</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div><Label className="text-xs">Palavra-passe atual</Label><Input type="password" value={cur} onChange={(e) => setCur(e.target.value)} data-testid="cp-current" /></div>
          <div><Label className="text-xs">Nova palavra-passe</Label><Input type="password" value={nw} onChange={(e) => setNw(e.target.value)} data-testid="cp-new" /></div>
          <div><Label className="text-xs">Confirmar nova</Label><Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="cp-confirm" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => setOpen(false)}>Cancelar</Button>
          <Button className="bg-sky-600 hover:bg-sky-700" onClick={submit} disabled={saving} data-testid="cp-submit">{saving ? "A guardar…" : "Guardar"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
